export default __webpack_public_path__ + "static/media/share icon.ecb44659.svg";